import GenerateGetQuoteNavigation from '../../screens/Quote/components/CreateGetQuote/GenerateGetQuoteNavigation';
import HallGetQuoteScreen from '../../screens/Quote/HallGetQuoteScreen';

const QuoteDetails = () => {
  return (
    <div className="h-100">
      <GenerateGetQuoteNavigation />
      <div style={{ height: 'calc(100% - 40px)' }}>
        <HallGetQuoteScreen />
      </div>
    </div>
  );
};

export default QuoteDetails;
